import { Box, Button, Container, Typography } from "@mui/material";
import { styles } from "./Styles";
import ActionGroup from "./ActionGroup";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CustomDatePick } from "../../../redux/action";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";

export const ChartHeader = ({
  setMonth,
  month,
  setOpenDatePicker,
  handleClick,
  name,
  disabled,
  excelOption,
  setName,
  openDatePicker,
  sendClearLocalState,
}: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openCSVWindow, setOpenCSVWindow] = useState(false);
  const [activeTab, setActiveTab] = useState<{ name: string; value: any }>({
    name: "header",
    value: "12",
  });

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue === "custom" || newValue === null) {
      setOpenDatePicker(true);
      setMonth("CUSTOM");
    } else {
      setMonth(newValue);
    }
    setName("");
    sendClearLocalState("CLEAR");
    dispatch(CustomDatePick("CLEAR"));
    setActiveTab({ value: newValue, name: "header" });
  };

  const handleDownload = () => handleClick();

  const handleClose = () => {
    dispatch(CustomDatePick("CLEAR"));
    setOpenDatePicker(false);
    // setOpenCSVWindow(false);
    setMonth("12");
    setActiveTab({ value: "12", name: "header" });
  };

  const handleBack = () => navigate(-1);

  return (
    <Box sx={styles.chartHeaderTitle}>
      <Container maxWidth="xl" sx={styles.reportContainer}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Button
            variant="contained"
            sx={{
              ...styles.downloadBtn,
              mx: "0!important",
              p: "5px!important",
            }}
            onClick={() => handleBack()}
          >
            <ArrowBackIcon />
          </Button>
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            sx={{
              mb: 0,
              fontSize: {
                xs: "14px",
                sm: "22px",
              },
            }}
          >
            My Care Bridge Analyzer
          </Typography>
        </Box>

        <ActionGroup
          name={"header"}
          value={month}
          disabled={disabled}
          excelOption={excelOption}
          onChange={handleChange}
          onDownload={handleDownload}
          onClose={handleClose}
          openDatePicker={openDatePicker}
          setOpenDatePicker={setOpenDatePicker}
          openCSVWindow={openCSVWindow}
          setOpenCSVWindow={setOpenCSVWindow}
          setMonth={setMonth}
          isActiveTab={activeTab}
        />
      </Container>
    </Box>
  );
};
